export enum GenderEnum {
  Female = 'Female',
  Male = 'Male',
}

export const maxModelArchiveSize = 300 * 1024 * 1024;
